import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';
import { RepresentantePipeSharedModule } from '../pipes';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';

import { RepresentanteMultiselectComponent } from './representante-multiselect.component';

@NgModule({
    imports: [
        SharedModule,
        RepresentantePipeSharedModule,
        NgxBootstrapMultiselectModule
    ],
    declarations: [
        RepresentanteMultiselectComponent
    ],
    exports: [
        RepresentanteMultiselectComponent
    ]
})
export class RepresentanteMultiselectModule { }
